var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z",
    fill: "#481B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDark);
export default __webpack_public_path__ + "static/media/Clock_Dark.0491b33e6da683c6c1844bcf20b16939.svg";
export { ForwardRef as ReactComponent };